import { InputMask } from '@react-input/mask'
import classNames from 'classnames'
import React, { FC, useEffect } from 'react'

import WarningIcon from '../../../../assets/icons/warning2.svg'
import { validateLoginCode } from '../../../../utils/stringUtils'
import styles from './LoginEmailForm.module.scss'

type Props = {
  code: string
  setCode: (v: string) => void
  error: string
  setError: (v: string) => void
  codeNotValid: boolean
  setCodeNotValid: (v: boolean) => void
}

const CodeInput: FC<Props> = ({ code, setCode, error, setError, codeNotValid, setCodeNotValid }) => {
  useEffect(() => {
    const newCodeNotValid = !!code && !validateLoginCode(code)
    setCodeNotValid(newCodeNotValid)
    if (!newCodeNotValid) setError('')
  }, [code])

  return (
    <>
      <InputMask
        mask='_______'
        pattern='\d'
        showMask
        replacement={{ _: /\d/ }}
        className={styles.codeFieldInput}
        modify={() => undefined}
        onMask={(e) => setCode(e.detail.input)}
      />

      <div className={classNames(styles.fieldError, { [styles.fieldErrorHidden]: !error })}>
        <WarningIcon />

        <span>{error}</span>
      </div>
    </>
  )
}

export default CodeInput
